import { API_PREFIX } from "./constant"
import { Request } from "./request"

export interface FileUploadTokenParams {
  bucketName?: string | undefined
  url?: any;
}



export function getFileUploadToken(params:FileUploadTokenParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/oss/endpoint/upload-token`,
    method: "GET",
    params,
  }
}
